export default "__VITE_ASSET__CizSfiP___"